import React, { useState, useEffect } from "react";
//import "./styles.css";
//import { Container, Row, Col, Modal, Button, Form, Dropdown, Table } from 'react-bootstrap';
// import LeftpanelAdmin from "../../../components/leftpanel/left-panel-admin";
// import HeaderPart from "../../../components/layout/header-admin/header";
//import "../user-details.css";
import DataTable from "react-data-table-component";
// import {
//     AddIcon,
//     DeleteIcon,
// } from "../../../assets/images";
import axios from "../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { CSVLink } from "react-csv";
import moment from "moment";
import { DATE_FORMAT } from "../../../constants/constants";
import { adminConfig } from "../../../utils/adminConfig";

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};

const CommissionReportDetails = () => {
  let token = localStorage.getItem("AuthToken");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const [CommissionList, setCommissionList] = useState([]);
  const [csvTitle, setcsvTitle] = useState("");
  const [pagination, setPagination] = useState({
    limit: 5,
    page: 1,
    totalPage: 7,
    totalRows: 10,
  });

  const allMembers = () => {
    let allMembers = members.map((item, i) => {
      return {
        title: item.title,
        createdAt: item.createdAt,
        id: item._id,
        //  (
        //   <div
        //     className={
        //       item.status == true ? "status_tran compl" : "status_tran icompl"
        //     }
        //   >
        //     {item.status}
        //   </div>
        // ),
      };
    });
    return allMembers;
  };
  // const handlePerRowsChange = (newPerPage) => {
  //     setLimit(newPerPage);

  //     setPage(1);
  // };
  const getMembers = () => {
    setLoading(true);
    axios
      .get(`/get-commission-report?limit=${limit}&page=${page}`, adminConfig())
      .then((res) => {
        setLoading(false);

        if (res.data.status) {
          setMembers(res.data.data);
          setPagination(res.data.pagination);
        } else {
          message.error("failed fetching member");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getMembers();
  }, [page, limit]);

  const csvdownload = (id) => {
    setLoading(true);
    axios
      .get(`/get-id-wise-commission-report/${id}`, adminConfig())
      .then((res) => {
        var csvData = [];

        setcsvTitle(res.data.data.title);
        res.data.data.user.forEach(function (currentElement, index) {
          csvData.push({
            name: currentElement.name,
            email: currentElement.email,
            commission: currentElement.commission,
          });
        });

        setCommissionList(csvData);

        setTimeout(() => {
          document.getElementById("csvclick").click();
          setLoading(false);
        }, 2000);
      })
      .catch((err) => {
        setLoading(false);

        console.log(err);
      });
  };

  const headersCsv = [
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },
    { label: "Commission", key: "commission" },
  ];

  const csvReport = {
    data: CommissionList,
    headers: headersCsv,
    filename: csvTitle + ".csv",
  };

  const columns = [
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
      width: "50%",
    },
    {
      name: "Created At",
      selector: (row) => moment(row.createdAt).format(DATE_FORMAT),
      sortable: true,
      width: "30%",
    },
    {
      name: "Action",
      selector: (row) => {
        return (
          <div>
            <button
              className="btn btn-primary"
              onClick={() => csvdownload(row.id)}
            >
              CSV Download
            </button>
          </div>
        );
      },
      sortable: true,
      width: "20%",
    },
  ];

  return (
    // <div>
    //     <HeaderPart />
    //     <div className='main_cont'>
    //         <LeftpanelAdmin />

    <LoadingOverlay active={loading} spinner text="Loading ...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <div className="text_field_partts">
              <div className="user_added">
                <div className="d-flex justify-content-between w-100">
                  <h2>Commission Report List</h2>
                  <CSVLink className="d-none" id="csvclick" {...csvReport}>
                    Export to CSV
                  </CSVLink>
                </div>

                <DataTable
                  columns={columns}
                  data={allMembers()}
                  pagination
                  striped
                  responsive
                  customStyles={customStyles}
                  subHeaderAlign="right"
                  subHeaderWrap
                  // paginationDefaultPage={page}
                  paginationServer
                  paginationTotalRows={pagination.totalRows}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[10, 15, 20, 40]}
                  onChangePage={(newPage) => setPage(newPage)}
                  onChangeRowsPerPage={(newLimit) => {
                      setLimit(newLimit);
                      setPage(1);
                  }}
                  progressComponent={<CustomLoader />}
                  noDataComponent={<EmptyDataLoader />}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
    //     </div>
    // </div>
  );
};
const CustomLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>Loading...</div>
  </div>
);
const EmptyDataLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>No data found...</div>
  </div>
);

export default CommissionReportDetails;
